import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ForgePageLoader } from "@/components/ForgeLoader";
import { usePermissions } from "@/hooks/usePermissions";
import type { Action, Module } from "@/lib/permissions";

interface ModuleRouteGateProps {
  module: Module;
  action?: Action;
  fallbackModules?: Module[];
  children: ReactNode;
  redirectTo?: string;
}

export function ModuleRouteGate({ module, action, fallbackModules = [], children, redirectTo = "/403" }: ModuleRouteGateProps) {
  const location = useLocation();
  const { can, canAccessModule, isLoading } = usePermissions();

  if (isLoading) {
    return <ForgePageLoader />;
  }

  const modulesToCheck = [module, ...fallbackModules];
  const canAccessRoute = modulesToCheck.some(
    (allowedModule) => canAccessModule(allowedModule) && (!action || can(allowedModule, action))
  );

  if (!canAccessRoute) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
